import React, { useContext, useEffect, useState } from "react";
import { FileSearchOutlined, FileDoneOutlined } from "@ant-design/icons";
import { EstadoVistaColaborador } from "enum/EstadoVistaColaborador";
import { useHistory } from "react-router";
import { CategoriaDocumento } from "enum/CategoriaDocumento";
import { useAtom } from "jotai";
import { formularioSeleccionadoAtom, documentoSeleccionadoAtom } from "../MisDocumentosMovilStorage";
import { visibleModalAlertaAtom } from "pages/v3/mis-pendientes/storage/MisDocumentosStorage";
import {
	loadingPdfAtom
} from "pages/onboarding/OnboardingStore";
import { useModalRegistrarAsistencia } from "pages/v3/mis-pendientes/common/hooks";

export const ItemDocumento = ({ documento, numero }) => {
	let history = useHistory();
	const [_, setDocumentoSeleccionado] = useAtom(documentoSeleccionadoAtom);
	const [, setFormularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [classNameEstado, setClassNameEstado] = useState(" loading");
	const [, setVisibleModalAlerta] = useAtom(visibleModalAlertaAtom);
	//const [, setLoadingPdf] = useAtom(loadingPdfAtom);

	const { abrirModal: abrirModalRegistrarAsistencia } = useModalRegistrarAsistencia();

	const onClickSeleccionarItem = () => {
		// if (documento.permitirVisualizarDocumento === false) {
		// 	setVisibleModalAlerta(true);
		// } else {
		if (documento.permitirVisualizarDocumento) {
			//setLoadingPdf(true);
			if (
				(documento.categoriaDocumentoId === CategoriaDocumento.FORMULARIO ||
					documento.categoriaDocumentoId === CategoriaDocumento.FORMATO_AUSENCIA) &&
				(documento.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE ||
					(documento.estadoAprobacion != null && documento.estadoAprobacion === "RECHAZADO"))
			) {
				setFormularioSeleccionado(documento);
				history.push(`/v3/mis-pendientes/visor-formulario-pdf/${documento.formularioId}/${documento.id}`);
			} else if (documento.categoriaDocumentoId === CategoriaDocumento.FLUJO_FIRMA) {
				setFormularioSeleccionado(documento);
				history.push(`/v3/mis-pendientes/visor-formulario-pdf/${documento.flujoFirmaId}/${documento.id}`);
			} else if (
				documento.categoriaDocumentoId === CategoriaDocumento.CARGA_DOCUMENTO &&
				(documento.estadoVistaColaborador !== EstadoVistaColaborador.FIRMADO ||
					(documento.estadoAprobacion != null && documento.estadoAprobacion === "RECHAZADO"))
			) {
				setDocumentoSeleccionado(documento);
				history.push(`/v3/mis-pendientes/carga-documentos/${documento.id}`);
			} else if (documento.categoriaDocumentoId === CategoriaDocumento.REGISTRO_ASISTENCIA) {
				abrirModalRegistrarAsistencia(documento);
			} else {
				history.push(`/v3/mis-pendientes/visor-pdf/${documento.id}`);
			}
		} else setVisibleModalAlerta(true);

		//}
	};

	const EstadoDocumento = ({ estado, estadoAprobacion }) => {
		if (estadoAprobacion != null && estadoAprobacion === "PENDIENTE" && estado === EstadoVistaColaborador.FIRMADO) {
			return "PENDIENTE APROBACIÓN";
		} else if (estadoAprobacion != null && estadoAprobacion === "RECHAZADO") {
			return "RECHAZADO";
		} else {
			switch (estado) {
				case EstadoVistaColaborador.PENDIENTE:
					return "PENDIENTE";

				case EstadoVistaColaborador.VISUALIZADO:
					return "VISUALIZADO";

				case EstadoVistaColaborador.FIRMADO:
					return "FIRMADO";

				default:
					return "-";
			}
		}
	};

	// const classNameEstado =
	// 	documento.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE ? " pendiente" : " visualizado";

	useEffect(() => {
		if (
			documento.estadoAprobacion !== null &&
			documento.estadoAprobacion === "PENDIENTE" &&
			documento.estadoVistaColaborador === EstadoVistaColaborador.FIRMADO
		) {
			setClassNameEstado(" pendiente-aprobacion");
		} else if (documento.estadoAprobacion !== null && documento.estadoAprobacion === "RECHAZADO") {
			setClassNameEstado(" rechazado");
		} else if (
			documento.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE &&
			documento.permitirVisualizarDocumento === true
		) {
			setClassNameEstado(" pendiente");
		} else if (
			documento.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE &&
			documento.permitirVisualizarDocumento === false
		) {
			setClassNameEstado(" bloqueado");
		} else {
			setClassNameEstado(" visualizado");
		}
	}, [documento]);

	return (
		<div className={"bandeja-entrada__item-documento" + classNameEstado} onClick={onClickSeleccionarItem}>
			<div className={"imagen" + classNameEstado}>
				{documento.estadoVistaColaborador !== EstadoVistaColaborador.PENDIENTE && <FileDoneOutlined />}
				{documento.estadoVistaColaborador == EstadoVistaColaborador.PENDIENTE && <FileSearchOutlined />}
			</div>
			<div className="informacion">
				<span className="item-documento__descripcion">
					<b>{documento.periodo}</b>
				</span>
				<span className="item-documento__tipo">
					{numero ? `${numero}. ` : ""}
					{documento.nombreDocumento}
				</span>
				<span className={"item-documento__estado" + classNameEstado}>
					<EstadoDocumento
						estado={documento.estadoVistaColaborador}
						estadoAprobacion={documento.estadoAprobacion}
					/>
				</span>
			</div>
		</div>
	);
};
